

export default class SortIndexNewRequest  {
	Id: string = '';
	SortIndex: number = 0;
	constructor(obj?: Partial<SortIndexNewRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
